export class DataLoginDto {

    constructor(
       public username : string,
       public password : string
    ) {}
}